
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';
import { Group } from '../../../models/backend-definitions.module';

@Injectable()
export class GroupEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    group: Group;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getGroup()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getGroup(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('group/wAll/' + this.routeParams.id).subscribe((res: Group ) => {
                    this.group = res;
                    this.onDataChanged.next(this.group);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(group): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('group/', group).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(group): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('group/', group).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(group): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('group/' + group.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
